import React, { Fragment, message } from 'react';
import { Space, Card, Table, Pagination, Modal, Tag, Tooltip, Button, Popconfirm, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { OrderedListOutlined } from '@ant-design/icons';
import { config } from "util/config";
import { httpClient } from "util/Api";
import { compareUIElementValue } from 'util/Compare';
import * as globalFunction from 'util/GlobalFunction';
import { operationalFunction, getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';
import DefaultDiv from 'components/UIBuilder/SectionComponent/DefaultDiv';
import JobDetailDiv from 'components/UIBuilder/SectionComponent/JobDetailDiv';

import DefaultTable from 'components/UIBuilder/SectionComponent/DefaultTable';
import DefaultGroupTable from 'components/UIBuilder/SectionComponent/DefaultGroupTable';
import SubJobTable from 'components/UIBuilder/SectionComponent/SubJobTable';
import DocumentTable from 'components/UIBuilder/SectionComponent/DocumentTable';
import JobPagingTable from 'components/UIBuilder/SectionComponent/JobPagingTable';
import JobChecklistTable from 'components/UIBuilder/SectionComponent/JobChecklistTable';

import DetailForm from 'components/UIBuilder/CustomComponent/DetailForm';
import CustomForm from 'components/UIBuilder/CustomComponent/CustomForm';
import CustomButton from 'components/UIBuilder/CustomComponent/CustomButton';
import AntDraggableModal from 'components/AntDraggableModal';
import * as createComponent from 'components/UIBuilder/CustomComponent/CreateComponent';

//做数据渲染组件的分选, 生成每个Section的UI, 包含其table和可能存在的自定义按钮
export default class DefaultSection extends React.Component {
  constructor(props) {
    super();
    this.state = {
      columns: [],
      data: [],
      pagination: {
        current: 1,
        ...config.component.Pagination
      },
      customFormSubmitting: false, // 提交表单是否在等待期间
      showModal: false, //是否显示表单
      popconfirmSubmitting: false, //确认气泡是否在等待期间
      componentType: null, //Create, Edit
      topFilterCounter: 0,
      topButtonCounter: 0,
      selectedRowKeys: [],
      componentDataSource: [],
      componentDefaultValue: [],
      searchParameter: null,
      section: null,
      state: false,
      showBottomButton: false,
      tableFooter: null,
      dataLoading: false,
      renderForm: false,
    }

    //定义一个表单引用, 方便后续处理
    this.customForm = React.createRef();
    this.child = React.createRef();
  };

  //页面启动
  componentDidMount() {
    this.setState({ section: this.props.section });
    setTimeout(() => {
      this.getComponentDataSource();
    }, config.setTimeoutMilliSecond);
  }

  getSectionDataByDefault() {
    this.child.current?.getSectionDataByDefault();
  }

  //找到过滤器数据源的组件, 获取其数据源
  getComponentDataSource() {
    let parameter = [];
    if (this.props.companyId !== undefined && this.props.companyId !== null) {
      parameter.push({ key: 'companyId', value: this.props.companyId })
    }
    if (this.props.moduleId !== undefined && this.props.moduleId !== null) {
      parameter.push({ key: 'moduleId', value: this.props.moduleId })
    }
    if (this.props.module !== undefined && this.props.module !== null) {
      parameter.push({ key: 'module', value: this.props.module })
    }
    this.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList.map((topFilter, i) => {
      topFilter.uieList.map(async (uie, j) => {
        getUieDataSource({ parameter: parameter, sectionName: this.props.sectionName, component: this, sectionComponent: this, pageComponent: this.props.pageComponent, uie: uie });
      })
    })
  }

  createDataViewer() {
    switch (this.props.section.type) {
      case 'DefaultDiv':
        return <DefaultDiv
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'JobDetailDiv':
        return <JobDetailDiv
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'DefaultGroupTable':
        return <DefaultGroupTable
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'SubJobTable':
        return <SubJobTable
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'DocumentTable':
        return <DocumentTable
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'JobPagingTable':
        return <JobPagingTable
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'JobChecklistTable':
        return <JobChecklistTable
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
      case 'DetailForm':
        return <DetailForm
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          component={this.props.section.componentList.filter(c => c.type === 'View')[0]}
          ref={this.child}
        />
      default:
        return <DefaultTable
          {...this.props}
          searchParameter={this.state.searchParameter != null ? this.state.searchParameter : this.props.searchParameter}
          viewConfig={this.state.section.componentList.filter(c => c.type === 'View')[0]}
          parentComponent={this}
          sectionComponent={this}
          ref={this.child}
        />
    }
  }

  createTopFilter(uie) {
    this.state.topFilterCounter++;
    return <span key={this.state.topFilterCounter}><Divider type="vertical" />{createComponent.createUIElement({ uie: uie, uieCounter: this.state.topFilterCounter, component: this, sectionComponent: this, pageComponent: this.props.pageComponent, value: this.state.componentDefaultValue[uie.source] })}</span>
  }

  createTopButton(button) {
    this.state.topButtonCounter++;
    return <span key={this.state.topButtonCounter}><Divider type="vertical" /><CustomButton button={button} section={this.props.section} sectionComponent={this} parameter={{ key: this.props.objId }} pageComponent={this.props.pageComponent} /></span>
  }

  render() {
    return (
      this.state.section !== null ?
        <div>
          <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <div className='data-table-div'>{this.createDataViewer()}</div>
          </Space>
        </div > : <></>
    );
  }
}
